import {combineReducers} from 'redux';
import Register from './register';
import SettingsReducer from './settings_reducer.js'
const rootReducer =combineReducers({
register:Register,settings:SettingsReducer
})
export default rootReducer;
